import { render, staticRenderFns } from "./EditVihicel.vue?vue&type=template&id=52f91d18&"
import script from "./EditVihicel.vue?vue&type=script&lang=js&"
export * from "./EditVihicel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports